// Merkan · Wörterbuch Englisch: Paket 4 (Übersicht, Suche, Rechte, Vertretung, Musterseite)
export default {
  // Übersicht (DB-03, DB-04, DB-09, DB-11, DB-12)
  '{n} Angebot seit 7 Tagen ohne Rückmeldung': '{n} quotation without response for 7 days',
  '{n} Angebote seit 7 Tagen ohne Rückmeldung': '{n} quotations without response for 7 days',
  '{n} Bestellung ohne Lieferanten-AB nach 2 Werktagen': '{n} purchase order without supplier confirmation after 2 working days',
  '{n} Bestellungen ohne Lieferanten-AB nach 2 Werktagen': '{n} purchase orders without supplier confirmation after 2 working days',
  '{n} Liefertermin des Lieferanten überschritten': '{n} supplier delivery date exceeded',
  '{n} Liefertermine von Lieferanten überschritten': '{n} supplier delivery dates exceeded',
  '{n} Bestellung abholbereit, Abholung nicht gebucht': '{n} order ready for collection, collection not booked',
  '{n} Bestellungen abholbereit, Abholung nicht gebucht': '{n} orders ready for collection, collection not booked',
  '{n} Eingangsrechnung mit Abweichung zur Bestellung, Freigabe gesperrt': '{n} supplier invoice deviates from the order, approval blocked',
  '{n} Eingangsrechnungen mit Abweichung zur Bestellung, Freigabe gesperrt': '{n} supplier invoices deviate from the order, approval blocked',
  '{n} Belegentwurf noch nicht ausgestellt': '{n} draft document not yet issued',
  '{n} Belegentwürfe noch nicht ausgestellt': '{n} draft documents not yet issued',
  '{n} deiner Vorgänge ist offen.': '{n} of your cases is open.',
  '{n} deiner Vorgänge sind offen.': '{n} of your cases are open.',
  'Vorgang, Kunde, Artikel oder Teilenummer suchen': 'Search case, customer, item or part number',
  'Du vertrittst heute {n} Kollegen. „Meine“ zeigt auch deren Vorgänge, Nachrichten und Freigaben.': 'You are standing in for {n} colleague(s) today. "Mine" also shows their cases, messages and approvals.',
  'Kennzahlen werden geladen': 'Loading key figures',
  'Bestellungen von Kunden': 'Customer orders',
  'Angebot angenommen im Zeitraum': 'quotation accepted in period',
  'Bestellungen bei Lieferanten': 'Supplier orders',
  '{n} ohne Lieferanten-AB': '{n} without supplier confirmation',
  'alle mit Lieferanten-AB': 'all confirmed by supplier',
  '{m} Mails, {d} Dokumente mit KI ausgewertet': '{m} emails, {d} documents analysed by AI',
  'Verarbeitet': 'Processed',
  'Freigaben': 'Approvals',
  '{n} Auftrag': '{n} order',
  '{n} Aufträge': '{n} orders',
  '{n} Eingangsrechnung': '{n} supplier invoice',
  '{n} Eingangsrechnungen': '{n} supplier invoices',
  'warten auf Freigabe': 'awaiting approval',
  '{n} Rechnung gebucht': '{n} invoice posted',
  '{n} Rechnungen gebucht': '{n} invoices posted',
  'dir zugewiesen, noch neu': 'assigned to you, still new',
  'zu {jahr}': 'vs {jahr}',
  'zur Vorwoche': 'vs previous 7 days',
  'zum Vorjahr': 'vs previous year',
  'zum Vormonat': 'vs previous month',
  'Vergleich mit dem ganzen Jahr {jahr}': 'Compared with the full year {jahr}',
  'Vergleich mit den 7 Tagen davor': 'Compared with the 7 days before',
  'Vergleich mit demselben Abschnitt des Vorjahres (1. Januar bis heute vor einem Jahr)': 'Compared with the same part of the previous year (1 January to this day last year)',
  'Vergleich mit demselben Abschnitt des Vormonats (Monatsanfang bis heute vor einem Monat)': 'Compared with the same part of the previous month (start of month to this day last month)',
  'wie im Vorzeitraum': 'same as previous period',
  'unverändert': 'unchanged',
  'neu': 'new',
  'Alle': 'All',
  'Meine': 'Mine',

  // Suche (SU-01 bis SU-07)
  'Zuletzt gesucht': 'Recent searches',
  'Zuletzt geöffnet': 'Recently opened',
  'Alle {n} anzeigen': 'Show all {n}',
  'Vorgang, Kunde, Artikel, Teilenummer, Beleg …': 'Case, customer, item, part number, document …',
  'Exakte Nummer, IMO oder Sendungsnummer und Enter öffnet direkt': 'Exact number, IMO or tracking number and Enter opens directly',
  'Exakte Vorgangs-, Beleg- oder Sendungsnummer und Enter öffnet direkt': 'Exact case, document or tracking number and Enter opens directly',
  'Sendungen': 'Shipments',
  'Sendung {nummer}': 'Shipment {nummer}',
  'Suche': 'Search',
  'Suchbegriff': 'Search term',
  'Suchergebnisse': 'Search results',
  'für „{q}“': 'for "{q}"',
  'Andere Schreibweise oder einen Teil der Nummer versuchen.': 'Try a different spelling or part of the number.',
  '{n} Treffer': '{n} results',
  'Weitere {n} laden': 'Load {n} more',
  'Art': 'Type',

  // Vertretung (BR-07)
  'Vertretung': 'Stand-in',
  'Vertretungen': 'Stand-ins',
  'Vertretung entfernen': 'Remove stand-in',
  'Die Vertretung von {person} durch {vertreter} wird entfernt. Bereits zugewiesene Vorgänge und Nachrichten bleiben beim Vertreter.': 'The stand-in of {vertreter} for {person} will be removed. Cases and messages already assigned stay with the stand-in.',
  'Vertretung entfernt.': 'Stand-in removed.',
  'Du vertrittst {person}': 'You are standing in for {person}',
  'Vertreten durch {vertreter}': 'Stand-in: {vertreter}',
  '{person} vertreten durch {vertreter}': '{person}, stand-in {vertreter}',
  '{von} bis {bis}': '{von} to {bis}',
  'mit Postfach': 'with mailbox',
  'läuft': 'active',
  'geplant': 'planned',
  'beendet': 'ended',
  'Während deiner Abwesenheit gehen neu zugewiesene Vorgänge und Nachrichten an deinen Vertreter. Er sieht deine Vorgänge, Nachrichten und Freigaben unter „Meine“ und auf Wunsch deine Postfächer. Die Vertretung endet automatisch.': 'While you are away, newly assigned cases and messages go to your stand-in. They see your cases, messages and approvals under "Mine" and, if you wish, your mailboxes. The stand-in ends automatically.',
  'Vertretung eintragen': 'Add stand-in',
  'Ich vertrete': 'I am standing in for',
  'Meine Vertretung': 'My stand-in',
  'Keine Vertretung eingetragen': 'No stand-in set',
  'Trage vor Urlaub oder Abwesenheit ein, wer dich vertritt.': 'Before holidays or absence, set who stands in for you.',
  'Weitere Vertretungen im Unternehmen': 'Other stand-ins in the company',
  'Bitte einen Vertreter wählen.': 'Please choose a stand-in.',
  'Vertreter und vertretene Person müssen verschieden sein.': 'Stand-in and absent person must be different.',
  'Das Ende darf nicht vor dem Beginn liegen.': 'The end must not be before the start.',
  'Der Zeitraum liegt in der Vergangenheit.': 'The period lies in the past.',
  'Vertretung eingetragen.': 'Stand-in saved.',
  'Wer wird vertreten': 'Absent person',
  'ich': 'me',
  'Vertreter': 'Stand-in',
  'Von': 'From',
  'Bis einschließlich': 'To (inclusive)',
  'Postfächer freigeben: der Vertreter liest und sendet aus den persönlichen und freigegebenen Postfächern': 'Share mailboxes: the stand-in reads and sends from personal and shared mailboxes',
  'Notiz': 'Note',
  'zum Beispiel Urlaub': 'for example holiday',
  'Bitte wählen': 'Please choose',

  // Musterseite (GR-06)
  'Musterseite': 'Pattern library',
  'Alle Bausteine der Oberfläche an einer Stelle. Nur für parlinex und die Geschäftsführung sichtbar.': 'All interface components in one place. Visible to parlinex and management only.',
  'Die Musterseite ist nur für parlinex und die Geschäftsführung sichtbar.': 'The pattern library is visible to parlinex and management only.',
  'Knöpfe': 'Buttons',
  'Primär': 'Primary',
  'Standard': 'Default',
  'Leise': 'Quiet',
  'Gefahr': 'Danger',
  'Klein': 'Small',
  'Nur Symbol': 'Icon only',
  'Gesperrt': 'Disabled',
  'Gehalten und bestätigt.': 'Held and confirmed.',
  'Halten zum Stornieren': 'Hold to cancel',
  'Marken': 'Badges',
  'bezahlt': 'paid',
  'fällig': 'due',
  'überfällig': 'overdue',
  'offen': 'open',
  'aktiv': 'active',
  'neutral': 'neutral',
  'Hinweise': 'Notices',
  'Information: Der Abruf läuft alle fünf Minuten.': 'Information: mail is fetched every five minutes.',
  'Erledigt: Die Rechnung wurde festgeschrieben.': 'Done: the invoice has been finalised.',
  'Warnung: Noch 25 % des Kontingents frei.': 'Warning: 25 % of the allowance left.',
  'Fehler: Die Verbindung zum Postfach ist fehlgeschlagen.': 'Error: the mailbox connection failed.',
  'Tabelle': 'Table',
  'Zebrastreifen, Beträge rechtsbündig, seitlich scrollbar': 'Zebra stripes, amounts right-aligned, scrolls sideways',
  'Formulare': 'Forms',
  'Hinweistext unter dem Feld': 'Help text below the field',
  'Deutschland': 'Germany',
  'Niederlande': 'Netherlands',
  'Lieferung an Bord im Hafen Hamburg.': 'Delivery on board in the port of Hamburg.',
  'Kontrollkästchen': 'Checkbox',
  'Panel, Dialog und Meldungen': 'Panel, dialog and notifications',
  'Panel öffnen': 'Open panel',
  'Dialog öffnen': 'Open dialog',
  'Wirklich löschen?': 'Delete?',
  'Bestätigung als Dialog mit Gefahr-Knopf.': 'Confirmation as a dialog with a danger button.',
  'Bestätigung': 'Confirmation',
  'Meldung': 'Notification',
  'Gespeichert.': 'Saved.',
  'Speichern nicht möglich.': 'Saving not possible.',
  'Fehlermeldung': 'Error notification',
  'Kacheln und Kontingent': 'Tiles and allowance',
  'seit 1. November': 'since 1 November',
  'Leerzustand und Laden': 'Empty state and loading',
  'Keine Einträge': 'No entries',
  'Leerzustand mit kurzer Erklärung und optionaler Aktion.': 'Empty state with a short explanation and an optional action.',
  'Neu anlegen': 'Create new',
  'Panel': 'Panel',
  'Seitenleiste von rechts, mobil bildschirmfüllend': 'Side sheet from the right, full screen on mobile',
  'Feld im Panel': 'Field in panel',
  'Inhalt des Panels.': 'Panel content.',
  'Dialog': 'Dialog',
  'OK': 'OK',
  'Ein Dialog für kurze Rückfragen.': 'A dialog for short questions.',

  // Ansicht als (BR-06)
  'Ansicht als': 'View as',
  'Ansicht als {rolle}': 'Viewing as {rolle}',
  'Ansicht als {rolle} gestartet. Nur Anzeige.': 'Viewing as {rolle}. Read only.',
  'Die App mit den Rechten einer Rolle ansehen, zum Beispiel um zu prüfen, was Auszubildende sehen. Nur Anzeige, der Wechsel wird protokolliert.': 'View the app with the permissions of a role, for example to check what trainees see. Read only, the switch is logged.',
  '{n} Benutzer': '{n} users',
  '{n} Recht': '{n} permission',
  '{n} Rechte': '{n} permissions',
  'Ansicht beenden': 'End view',
  'Ansehen': 'View',
  'Nur Anzeige, Änderungen sind gesperrt.': 'Read only, changes are blocked.',
  'Ansicht als: nur Anzeige. Änderungen sind in dieser Ansicht gesperrt.': 'View as: read only. Changes are blocked in this view.',
  'Begonnen': 'Started',
  'Beendet': 'Ended',

  // Änderungsprotokoll
  'Sicherheitsprotokoll': 'Security log',
  'Postfachzugriffe': 'Mailbox access',
  'DATEV-Exporte': 'DATEV exports',
  'Belegversand': 'Document dispatch',
  'Eingangsrechnungen': 'Supplier invoices',
  'Eingangsrechnungspositionen': 'Supplier invoice lines',
  'Wareneingänge': 'Goods receipts',
} satisfies Record<string, string>;
